import { FC, useEffect, useState } from 'react'
import Style from './Footer.module.scss'
import { BitazzaText } from '../../../../components'
import { Space } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { SVGs } from '../../../../assets'
import { appCallbackHandler } from '../../../../util/AppCallbackHandler'
import { getComparedTextOverall } from '../../../../util/getComparedText'

interface Props {
    seasonTitle?: string
    onClaimNftHandler: () => void
    userTier?: string | null
    rewards?: prizeSeasonStatus[]
    userInfo: UserInformationT
    total?: number
    userRank?: number | null
    isFDWLink: boolean
    isLoading?: boolean
}
export const Footer: FC<Props> = ({
    seasonTitle,
    onClaimNftHandler,
    userTier,
    isFDWLink,
    userInfo,
    total,
    userRank,
    isLoading,
}) => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    const [shouldDisableBtn, setShouldDisableBtn] = useState(false)
    const [shareData, setShareData] = useState({})
    const [disableButton, setDisableButton] = useState<boolean>(false)

    useEffect(() => {
        if (isFDWLink) {
            setShouldDisableBtn(true)
        }
    }, [isFDWLink])

    useEffect(() => {
        const arePrizeAllMinted = userInfo.prizes.filter(
            (el: prizeSeasonStatus) =>
                el.status !== 'minted' && el.status !== 'minting-requested'
        )

        if (!arePrizeAllMinted.length || isLoading) {
            setDisableButton(true)
        } else {
            setTimeout(() => {
                setDisableButton(false)
            }, 1000)
        }
    }, [userInfo.prizes, isLoading])

    const claimNftHandler = () => {
        !disableButton && !isLoading && onClaimNftHandler()

        if (shouldDisableBtn) {
            setDisableButton(true)
        }
    }

    const tier =
        userTier === 'n/a' ||
        userTier === 'N/A' ||
        userTier === 'Na' ||
        !userTier
            ? null
            : userTier

    useEffect(() => {
        const higherThanText = getComparedTextOverall(userRank, total)
        const data = userInfo
        const newObj = Object.assign({ higherThanText: higherThanText }, data)
        setShareData(newObj)
    }, [userRank, total])

    return (
        <Space className={Style.container} direction="vertical">
            <div className={Style.wrapper}>
                <div
                    className={Style.share}
                    onClick={() => appCallbackHandler('sendSharing', shareData)}
                >
                    <img src={SVGs.share} alt="share" />
                    <BitazzaText
                        format="t18"
                        color="#FFF"
                        content={t('text_share')}
                        bold
                    />
                </div>

                {tier ? (
                    <div
                        className={Style.claimNftButton}
                        onClick={claimNftHandler}
                        style={{
                            background: disableButton
                                ? 'gray'
                                : 'linear-gradient(90.78deg, #ffb800 0%, #d89c45 100%)',
                        }}
                    >
                        <BitazzaText
                            format="t18"
                            color="#000"
                            content={
                                tier ? t('txt_claim_nft') : 'Go To Next Season'
                            }
                            bold
                        />
                    </div>
                ) : null}
            </div>

            <BitazzaText
                onClick={() => navigate('/end-season')}
                format="t18"
                color="#D4B578"
                content={`${t('txt_view')} ${seasonTitle} ${t('txt_summary')}`}
                bold
                textAlign="center"
            />
        </Space>
    )
}
